import React, { useEffect, useMemo, useState } from 'react';
import { gatewayApi } from '../services/gateway';
import { HelpHint } from '../common/SafeIcon';

export default function SuppressionList() {
  const [rows,setRows]=useState([]);
  const [clients,setClients]=useState([]);
  const [filter,setFilter]=useState('');
  const [form,setForm]=useState({client_id:'',email:'',reason:'manual',notes:''});
  const [saving,setSaving]=useState(false);
  const [error,setError]=useState('');
  const reload=async()=>{const [a,b]=await Promise.all([gatewayApi.listSuppressions(),gatewayApi.listClients()]);setRows(a.data||[]);setClients(b.data||[]);};
  useEffect(()=>{reload().catch(e=>setError(e.message));},[]);
  const visible=useMemo(()=>rows.filter(r=>(r.email+' '+r.reason+' '+r.client_id).toLowerCase().includes(filter.toLowerCase())),[rows,filter]);
  const save=async(e)=>{
    e.preventDefault();setError('');setSaving(true);
    try{
      await gatewayApi.createSuppression(form);await reload();setForm({client_id:'',email:'',reason:'manual',notes:''});
    }catch(err){setError(err.message||'Unable to save suppression');}
    finally{setSaving(false);}
  };
  const remove=async(row)=>{
    if(!window.confirm('Remove this suppression? Emails to this address may resume.'))return;
    setSaving(true);
    try{await gatewayApi.deleteSuppression(row.id);await reload();}
    catch(err){setError(err.message||'Unable to remove suppression');}
    finally{setSaving(false);}
  };
  return <div className="space-y-6 pb-12">
    <header><h2 className="text-2xl font-bold text-slate-900">Email suppression list</h2>
      <p className="text-sm text-slate-500">Persistent PocketBase records that prevent sending to blocked recipients.</p>
    </header>
    {error&&<div role="alert" className="rounded-xl border border-red-200 bg-red-50 p-3 text-red-700">{error}</div>}
    <form onSubmit={save} className="rounded-2xl border border-slate-200 bg-white p-5 space-y-4">
      <h3 className="font-semibold">Suppress an email address</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="suppression-client">Client</label><HelpHint label="Client"/></div>
          <select id="suppression-client" required className="block mt-1 w-full p-2 rounded-lg border" value={form.client_id} onChange={e=>setForm(p=>({...p,client_id:e.target.value}))}>
            <option value="">Select client</option>{clients.map(c=><option value={c.id} key={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="suppression-email">Email</label><HelpHint label="Email"/></div>
          <input id="suppression-email" required type="email" className="block mt-1 w-full p-2 rounded-lg border" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))}/>
        </div>
        <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="suppression-reason">Reason</label><HelpHint label="Reason"/></div>
          <select id="suppression-reason" className="block mt-1 w-full p-2 rounded-lg border" value={form.reason} onChange={e=>setForm(p=>({...p,reason:e.target.value}))}>
            {['manual','unsubscribe','bounce','complaint','blocked'].map(k=><option key={k} value={k}>{k}</option>)}
          </select>
        </div>
      </div>
      <button disabled={saving} className="rounded-xl bg-blue-600 px-5 py-2.5 text-white disabled:opacity-50">Add suppression</button>
    </form>
    <section className="rounded-2xl border bg-white overflow-hidden">
      <div className="p-4"><input aria-label="Search suppressions" className="w-full border rounded-lg p-2" placeholder="Search suppressed email or client" value={filter} onChange={e=>setFilter(e.target.value)}/></div>
      <div className="overflow-x-auto"><table className="w-full text-sm text-left">
        <thead className="bg-slate-50"><tr><th className="p-3">Email</th><th className="p-3">Client</th><th className="p-3">Reason</th><th className="p-3">Date</th><th className="p-3">Action</th></tr></thead>
        <tbody>{visible.map(row=><tr className="border-t" key={row.id}><td className="p-3">{row.email}</td>
          <td className="p-3">{clients.find(c=>c.id===row.client_id)?.name||row.client_id}</td><td className="p-3">{row.reason}</td><td className="p-3">{row.created}</td>
          <td className="p-3"><button disabled={saving} className="text-red-700 disabled:opacity-50" onClick={()=>remove(row)}>Remove</button></td>
        </tr>)}</tbody>
      </table></div>{!visible.length&&<p className="p-4 text-slate-500">No matching suppressed addresses.</p>}
    </section>
  </div>;
}